import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
 
export default new Vuex.Store({
	state: {
		LOADING: false,//显示加载中的状态标志
		SHOWING: true,//显示加载加载失败的状态
		CardList:[],//绑定卡的信息列表
		AppointInfo:{},//预约成功的信息,
	},
	mutations: {
		showLoading(state) {//加载图标显示
			state.LOADING = true;
		},
		hideLoading(state) {//加载图标隐藏
			state.LOADING = false;
		},
		showRefresh(state) {
			state.SHOWING = true;
		},
		hideRefresh(state) {
			state.SHOWING = false;
		},
		changeCardList(state,data){
			state.CardList=data
			let res=JSON.stringify(data)
			sessionStorage.setItem("CardLsit",res)
			
		},
		changePlaceOrder(state){
			state.PlaceOrder=false
		},
		changeAppointInfo(state,data){
			state.AppointInfo=data
		},
	},
	actions:{
        
	}
});


// WEBPACK FOOTER //
// ./src/store/index.js